(ns manage.content-variant-page.entities.tagging-tracker-ocp.db
  (:require [manage.content-variant-page.entities.tagging.db :as tagging]
            [manage.content-variant-page.entities.tracker.db :as tracker]
            [mate.re-frame :as mr]
            [re-frame.core :as rf]))

(rf/reg-event-db ::init
  (fn [db _]
    (let [adset (-> db :resource.adset/one :value)]
      (-> db
          (assoc ::tagging/tagging-params (->> (:clickThroughUrlTagging adset)
                                               (mapv (fn [{:keys [name values]}]
                                                       [name (apply str values)])))
                 ::tracker/tracker-params (:trackers adset))))))

(rf/reg-sub ::initialized
  :<- [::tagging/tagging-params]
  :<- [::tracker/tracker-params]
  (fn [[tagging-params tracker-params] _]
    (and (some? tagging-params)
         (some? tracker-params))))

(rf/reg-sub ::content-has-changed
  (fn [db _]
    (or (tagging/content-has-changed? db)
        (tracker/content-has-changed? db))))

(rf/reg-sub ::save-button-enabled
  :<- [::content-has-changed]
  :<- [::tracker/can-save-trackers]
  (fn [[content-has-changed can-save-trackers] _]
    (and content-has-changed can-save-trackers)))

(rf/reg-sub ::ongoing-save
  (fn [db _]
    (boolean (::ongoing-save db))))

(rf/reg-event-fx ::save
  (fn [{:keys [db]} _]
    (let [click-through-url-tagging (tagging/value-to-save db)
          trackers (tracker/value-to-save db)]
      (-> {:db db}
          (mr/update-db assoc ::ongoing-save true)
          (mr/update-db update-in [:resource.adset/one :value] assoc
                        :clickThroughUrlTagging click-through-url-tagging
                        :trackers trackers)
          (mr/conj-fx [:dispatch [:resource.adset/patch
                                  {:clickThroughUrlTagging click-through-url-tagging
                                   :trackers trackers}
                                  ;; Ugly code. This should be improved once the resources are stored as a part of the loading process.
                                  {:on-success (fn [response]
                                                 (rf/dispatch [::save-on-success])
                                                 (rf/dispatch [:resource.adset/patch-success response]))
                                   :on-failure (fn [response]
                                                 (rf/dispatch [::save-on-failure response])
                                                 (rf/dispatch [:resource.adset/patch-failure response]))}]])))))

(rf/reg-event-fx ::save-on-success
  (fn [{:keys [db]} _]
    (-> {:db db}
        (mr/update-db dissoc ::ongoing-save)
        tracker/dissoc-errors-from-tracker-params
        (mr/conj-fx [:dispatch [:toaster-bus/add {:id ::save-on-success
                                                  :type :success
                                                  :message "New tagging & tracker values have been saved"}]])
        (mr/conj-fx [:dispatch [:entity/close-view]]))))

(rf/reg-event-fx ::save-on-failure
  (fn [{:keys [db]} [_ response-body]]
    (let [tracker-errors (get-in response-body [:value :error :details :problems])]
      (-> {:db db}
          (mr/update-db dissoc ::ongoing-save)
          (tracker/reduce-errors-to-tracker-params-effects tracker-errors)
          (mr/conj-fx [:dispatch [:toaster-bus/add {:id ::save-on-failure
                                                    :type :error
                                                    :message "Problem while saving tagging & tracker values"}]])))))

(rf/reg-event-db ::destroy
  (fn [db _]
    (dissoc db
            ::tagging/tagging-params
            ::tracker/tracker-params)))
